import { useCallback, useEffect, useMemo, useState } from 'react';

type UseSessionStorageTransferReturn = {
    value: string | null;
    setValue: (newValue: string) => void;
};

export const useSessionStorageTransfer = (storageKey: string): UseSessionStorageTransferReturn => {
    const [value, setValueState] = useState<string | null>(null);

    useEffect(() => {
        const storedValue = sessionStorage.getItem(storageKey);

        if (storedValue) {
            setValueState(storedValue);
            sessionStorage.removeItem(storageKey);
        }
    }, [storageKey]);

    const setValue = useCallback(
        (newValue: string) => {
            sessionStorage.setItem(storageKey, newValue);
        },
        [storageKey],
    );

    return useMemo(() => ({ value, setValue }), [value, setValue]);
};
